
// Demo-only guide profiles. Public directories and signup use real Supabase
// profiles and must never treat these examples as registered guides.
export const MOCK_GUIDES = [
  {
    id: "dilnoza-kamilova",
    name: "Дилноза Камилова",
    region: "Самарканд",
    citySlug: "samarkand",
    regionsCount: 2,
    rating: 4.9,
    reviews: 28,
    bio: "Историк и гастрономический гид — истории Шёлкового пути становятся личными и запоминающимися.",
    languages: ["English", "Russian", "Uzbek"],
    languageSlugs: ["english", "russian", "uzbek"],
    specialties: ["История", "Гастротуры"],
    pricePerDay: 95,
    pricePerHour: 15,
    photo: "/images/guides/guide-1.png",
  },
  {
    id: "aziz-karimov",
    name: "Азиз Каримов",
    region: "Ташкент",
    citySlug: "tashkent",
    regionsCount: 1,
    rating: 4.7,
    reviews: 14,
    bio: "Городской гид, который знает районы, базары и современную архитектуру Ташкента.",
    languages: ["Russian", "Uzbek"],
    languageSlugs: ["russian", "uzbek"],
    specialties: ["Городские прогулки", "Архитектура"],
    pricePerDay: 80,
    pricePerHour: 12,
    photo: "/images/guides/guide-2.png",
  },
  {
    id: "mariya-sokolova",
    name: "Мария Соколова",
    region: "Бухара",
    citySlug: "bukhara",
    regionsCount: 1,
    rating: 4.8,
    reviews: 20,
    bio: "Эксперт по памятникам Бухары, увлекательно рассказывает истории старого города.",
    languages: ["English", "Russian"],
    languageSlugs: ["english", "russian"],
    specialties: ["История", "Музеи"],
    pricePerDay: 70,
    pricePerHour: 10,
    photo: "/images/guides/guide-3.png",
  },
  {
    id: "omid-rahmon",
    name: "Омид Рахмон",
    region: "Хива",
    citySlug: "khiva",
    regionsCount: 1,
    rating: 4.6,
    reviews: 8,
    bio: "Местный фотограф и гид, который красиво «раскадровывает» Хиву для гостей.",
    languages: ["Uzbek", "Russian"],
    languageSlugs: ["uzbek", "russian"],
    specialties: ["Наследие", "Фототуры"],
    pricePerDay: 60,
    pricePerHour: 9,
    photo: "/images/guides/guide-4.png",
  },
  {
    id: "nurmukhammed-t",
    name: "Нурмухаммед Т.",
    region: "Нукус",
    citySlug: "nukus",
    regionsCount: 1,
    rating: 4.5,
    reviews: 5,
    bio: "Хорошо разбирается в коллекции Нукусского музея и современном искусстве региона.",
    languages: ["Russian"],
    languageSlugs: ["russian"],
    specialties: ["Современное искусство", "Музеи"],
    pricePerDay: 50,
    pricePerHour: 8,
    photo: "/images/guides/guide-5.png",
  },
  {
    id: "laylo-ismailova",
    name: "Лайло Исмаилова",
    region: "Наманган",
    citySlug: "namangan",
    regionsCount: 1,
    rating: 4.8,
    reviews: 12,
    bio: "Гид по пешим маршрутам Ферганской долины и окрестным горам.",
    languages: ["Uzbek", "Russian"],
    languageSlugs: ["uzbek", "russian"],
    specialties: ["Природа", "Пешие туры"],
    pricePerDay: 65,
    pricePerHour: 10,
    photo: "/images/guides/guide-6.png",
  },
  {
    id: "bek-rasulov",
    name: "Бек Расулов",
    region: "Фергана",
    citySlug: "fergana",
    regionsCount: 1,
    rating: 4.4,
    reviews: 7,
    bio: "Знаток базаров и ремесленных мастерских, проводит мастер-классы прямо в туре.",
    languages: ["Uzbek", "English"],
    languageSlugs: ["uzbek", "english"],
    specialties: ["Ремёсла", "Базары"],
    pricePerDay: 55,
    pricePerHour: 9,
    photo: "/images/guides/guide-7.png",
  },
  {
    id: "ali-mirzo",
    name: "Али Мирзо",
    region: "Андижан",
    citySlug: "andijan",
    regionsCount: 1,
    rating: 4.3,
    reviews: 4,
    bio: "Дружелюбный гид для семейных туров и знакомства с местной культурой.",
    languages: ["Russian", "Uzbek", "English"],
    languageSlugs: ["russian", "uzbek", "english"],
    specialties: ["Культура", "Семейные туры"],
    pricePerDay: 45,
    pricePerHour: 7,
    photo: "/images/guides/guide-8.png",
  },
];
